<template>
	<div>
  	<router-view></router-view>
	</div>
</template>

<script>

import List from './cloudrec/List'
import Editor from './cloudrec/Editor'
import CreateClip from './cloudrec/CreateClip'

export default {
	routes: [
		{
			path: "",
			redirect: "/cloudrec/list"
		},
		{
			path: "list",
			component: List,
			name: "CloudRec list"
		},
		{
			path: "clip",
			component: CreateClip,
			name: "CloudRec create clip"
		},
		{
			path: "event/:uuid",
			props: true,
		  name: "CloudRec event",
      component: Editor,
		}
	]
}
</script>